import { memo, useCallback, useEffect, useState } from "react";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import { useTranslation } from "react-i18next";
import { useFetch } from "@4uhub/lib4uhub";
import { tokenTemporaryService } from "../../../../services/tokenTemorary.service";
import { ActionButton } from "../../Reports/ReportsModal/FileItem/Actions/ActionButton/ActionButton";
import {
  getLaboratorialExamsResultLabPdf,
  getLaboratorialExamsResultLabPdfAsTemporary,
  getLaboratorialExamsResultLabPdfList,
  getLaboratorialExamsResultLabPdfListAsTemporary,
} from "../../../../services/laboratorialExams.service";

type Props = { identifier: number, cdnUrl: boolean };

const translationPath = "components.reportsModal.actions.";

export const ViewExamsResultLabPdfTable = memo(({ identifier, cdnUrl }: Props) => {
  const { t } = useTranslation();

  const [selectedFile, setSelectedFile] = useState<string | ArrayBuffer | null>(null);
  const [shouldOpenFile, setShouldOpenFile] = useState(false);


  const isTemporaryAccess = !!tokenTemporaryService.getTemporaryAccessToken();

  const { sendRequest: fetchOrigins, loading: originsLoading } = useFetch(
    isTemporaryAccess
      ? getLaboratorialExamsResultLabPdfListAsTemporary
      : getLaboratorialExamsResultLabPdfList,
  );
  const { sendRequest: fetchLabFile, loading: nonLabLoading } = useFetch(
    isTemporaryAccess
      ? getLaboratorialExamsResultLabPdfAsTemporary
      : getLaboratorialExamsResultLabPdf,
  );

  const isLoading = originsLoading || nonLabLoading;

  const openInNewTabHandler = useCallback(async () => {
    const { data: origins, success } = await fetchOrigins(identifier);
    if (!success || !origins || origins.length === 0) {
      setSelectedFile(null);
      return;
    }
    const { data, success: okLabFile } = await fetchLabFile(
      origins[0].identifier,
    );
    if (okLabFile && data) {
      setSelectedFile(data);
    } else {
      setSelectedFile(null);
    }
    setShouldOpenFile(true);
  }, [fetchOrigins, identifier, fetchLabFile]);

  useEffect(() => {
    if (!shouldOpenFile || !selectedFile) return;

    setShouldOpenFile(false);

    // if (cdnUrl) {
    //   window.open(selectedFile as string, "_blank");
    //   return;
    // }

    try {
      let blob: Blob;
      if (selectedFile instanceof ArrayBuffer) {
        blob = new Blob([selectedFile], { type: "application/pdf" });
      } else {
        const base64String = (selectedFile as string).includes(",")
          ? (selectedFile as string).split(",")[1]
          : (selectedFile as string);

        const byteCharacters = atob(base64String);
        const byteArray = new Uint8Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteArray[i] = byteCharacters.charCodeAt(i);
        }
        blob = new Blob([byteArray], { type: "application/pdf" });
      }

      const blobUrl = URL.createObjectURL(blob);
      const newTab = window.open();
      if (newTab) newTab.location.href = blobUrl;
    } catch (e) {
      console.error("[PDF] Erro ao abrir arquivo:", e);
    }
  }, [selectedFile, shouldOpenFile, cdnUrl]);

  return (
    <ActionButton
      icon={OpenInNewRoundedIcon}
      tooltip={t(`${translationPath}open`)}
      disabled={isLoading}
      onClick={openInNewTabHandler}
      loading={isLoading}
    />
  );
});